import {httpService} from "@/modules/common/services"
import {getQuery} from "@/modules/common/utils"

const getMessages = (uid, params) => getQuery(`conversations/${uid}/messages`, params)

const sendMessage = async (uid, data) => {
    const res = await httpService.post(`conversations/${uid}/messages`, data);
    if (res.status === "Error") {
		return {error: res.message};
	} else {
		return {message: res}
  }
}

const update = async (uid, data) => {
	try {
		const res = await httpService.put(`conversations/${uid}`, data);
		return {conversation: res}
	} catch(e) {
		throw {error: e.message}
	}
}

export default {
  getMessages,
	sendMessage,
	update,
}